import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { themeQuartz } from 'ag-grid-community';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons/faArrowUpRightFromSquare';
import { DateCellRenderer, LinkCellRenderer } from '../components/grid/CellRenderers';
import { useMsal } from '@azure/msal-react';
import { fetchAuthorized } from '../utils/fetchAuthorized';
import PaginationGrid from '../components/grid/PaginationGrid';
import { AddClient } from '../components/client/AddClient';

const employeeComponent = (props) => {
  return (
  <Link className="btn-primary" to={`/Clients/${props.value}`}>
    <FontAwesomeIcon icon={faArrowUpRightFromSquare} size="lg" />
  </Link>
  );
}

export function HomePage() {
  const { instance } = useMsal();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [totalClientCount, setTotalClientCount] = useState(0);

  const getClientCount = async () => {
    try {
      if(totalClientCount > 0) return;
      const response = await fetchAuthorized(instance, `${process.env.REACT_APP_API_URL}clients/count`)
      if(!response.ok) {
        throw new Error('Could not retrieve client count.');
      }
      const data = await response.json();
      setTotalClientCount(data);
    } catch (error) {
      setError(error.message);
    }
  };

  const getClients = async (pageNumber, pageSize, sortField, sortDirection) => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_URL}clients?pageNumber=${pageNumber}&pageSize=${pageSize}&sortField=${sortField}&sortDirection=${sortDirection}`;
      const response = await fetchAuthorized(instance, url);
      if(!response.ok) {
        throw new Error('Could not retrieve clients.');
      }
      const data = await response.json();
      setClients(data);

    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if(clients && clients.length > 0)
        return;
    getClientCount();
    getClients(1, 12, 'createdDate', 'desc');
  }, []);

  const columnDefs = [
    { field: "name", filter: false, flex: 1, cellRenderer: LinkCellRenderer, cellRendererParams: { baseUrl: '/Clients/' } },
    { field: "createdDate", headerName: "Created Date", cellDataType: 'date', filter: false, flex: 1, cellRenderer: DateCellRenderer },
    { field: "enterpriseName", headerName: "Enterprise", cellDataType: 'string',  filter: false, flex: 1, cellRenderer: LinkCellRenderer, cellRendererParams: { baseUrl: '/Enterprises/', colName: 'enterpriseId' } },
    { field: "function", cellDataType: 'string', filter: false, flex: 1 },
    { field: "geographies", headerName: "Geography", valueFormatter: p => p.value ? p.value.join(" | ") : "", filter: false, flex: 1 },
    { field: "problem", headerName: "Problem", cellDataType: 'string', filter: false, flex: 1 },
    { field: "id", headerName: "", cellClass: "justify-content-center", cellRenderer: employeeComponent }
  ];

  //remove enterpriseName, function, geography, and problem columns if no data
  const hasEnterpriseName = clients.some(a => a.enterpriseName);
  if(!hasEnterpriseName) {
      const index = columnDefs.findIndex(a => a['field'] === "enterpriseName");
      if(index !== -1) {
          columnDefs.splice(index, 4); // remove columns
      }
  }

  return (
    <div className="container-fluid px-5 d-flex flex-column">
      <h2>Designs</h2>
      {
        error ? (
          <p>Error: {error}</p>
        ) : (
          <PaginationGrid
            gridId="client-grid"
            theme={themeQuartz}
            rowData={clients}
            columnDefs={columnDefs}
            rowHeight={50}
            loading={loading}
            totalRows={totalClientCount}
            getData={getClients}
          />
        )
      }
      { !loading && 
        <AddClient
          modal
          clients={clients}
          onAddClient={(newClients) => setClients(newClients)}
        />
      }
    </div>
  );
}
